import { registerTrackingLink } from "../tracking/TrackingLink";
import { initEventHistory } from "./eventHistory/EventHistory";
import { eventLoader } from "@otto-ec/global-resources/event-loader";
import { EntryRule } from "./eventHistory/EntryRule";

eventLoader.onReady(1, initEventHistory);
eventLoader.onReady(2, EntryRule.register);
eventLoader.onReady(10, registerTrackingLink);
